import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tool-tips',
  templateUrl: './tool-tips.component.html',
  styleUrls: ['./tool-tips.component.css']
})
export class ToolTipsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
